import b64EncodeUnicode from './base64Encoder';

//creates template, with 
//arg name: name/path of template
//arg content: template content, 
//arg isContentEncoded: tells if the content is already base64-encoded, if not, encodes it
function createTemplate(name, content, isContentAlreadyEncoded = false) {
    let templateContent;
    if (isContentAlreadyEncoded) {
        templateContent = content;
    } else {
        templateContent = b64EncodeUnicode(content);
    }
    
    return {
        "@": {
            "Mode": 0,
            "Name": name,
            "Lock": 0
        },
        "Lqt_Tpl": templateContent
    };
}

export default createTemplate;